import { colors, roleColors } from "../../ui/colors";

import KitchenIcon from "@mui/icons-material/Kitchen";
import BathtubIcon from "@mui/icons-material/Bathtub";
import BedIcon from "@mui/icons-material/Bed";
import WeekendIcon from "@mui/icons-material/Weekend";
import DiningIcon from "@mui/icons-material/Dining";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";

export const renderIconResidential = (name = "", active = false) => {
  const color = active ? roleColors.residential.base : colors.gray[400];
  const n = name.toLowerCase();

  // Cocina
  if (n.includes("kitchen") || n.includes("cooking"))
    return <KitchenIcon sx={{ color }} />;

  // Baños
  if (n.includes("bath") || n.includes("restroom") || n.includes("shower") || n.includes("toilet"))
    return <BathtubIcon sx={{ color }} />;

  // Dormitorios
  if (n.includes("bedroom") || n.includes("room") || n.includes("sleep"))
    return <BedIcon sx={{ color }} />;

  // Comedor
  if (n.includes("dining") || n.includes("table"))
    return <DiningIcon sx={{ color }} />;

  // Limpieza general (regular, deep, move-in/out, one time, living room, upholstery)
  if (
    n.includes("deep") ||
    n.includes("move-in") ||
    n.includes("move out") ||
    n.includes("upholstery")
  )
    return <WeekendIcon sx={{ color }} />;

  // Fallback
  return <CleaningServicesIcon sx={{ color }} />;
};
